"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all actions
 * Actions APIs
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionGroup = void 0;
/**
 * Enumeration of available groups of actions that can be queried. watch: (aka, \"Watch Now\")   a) Watch Live   b) Watch from My Shows   c) Watch from provider (eg, Netflix, Amazon Prime)   etc. scheduleBookmark:   a) Bookmark this show   b) Delete Bookmark   etc. scheduleOnepass:   a) Create Onepass   b) Cancel Onepass   etc. scheduleRecording:   a) Record this show   b) Modify recording   etc. rent:   a) Rent this Show   etc. subscribe:   a) Subcribe to Socu   b) Subscribe to Ndvr   etc.
 * @export
 * @enum {string}
 */
exports.ActionGroup = {
    Watch: 'watch',
    ScheduleBookmark: 'scheduleBookmark',
    ScheduleOnepass: 'scheduleOnepass',
    ScheduleRecording: 'scheduleRecording',
    Rent: 'rent',
    Subscribe: 'subscribe'
};
